'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { DirectionProvider as DirectionProviderPrimitive } from '@radix-ui/react-direction';
/**
 * Provider for the direction
 * @example
 * ```ts
 * import { DirectionProvider } from "@cloud/shared/ui"
 *
 * <DirectionProvider direction="ltr">
 *   <App />
 * </DirectionProvider>
 * ```
 */
export function DirectionProvider({ direction, children, }) {
    return _jsx(DirectionProviderPrimitive, { dir: direction, children: children });
}
